var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_1530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1034 5.07813H2.84296C1.2731 5.07813 0 6.35123 0 7.92148V37.8328C0 39.4031 1.2731 40.6762 2.84296 40.6762H46.1034C47.6737 40.6762 48.9464 39.4031 48.9464 37.8328V7.92148C48.9464 6.35123 47.6737 5.07813 46.1034 5.07813Z",
    fill: "#FFEB7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1034 5.07812H43.0058V35.9496H0V37.8328C0 39.4031 1.2727 40.6762 2.84296 40.6762H46.1034C47.6737 40.6762 48.9464 39.4031 48.9464 37.8328V7.92148C48.9464 6.35123 47.6737 5.07812 46.1034 5.07812Z",
    fill: "#EFB525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7227 22.6488L0.931152 39.9371C1.43619 40.3961 2.10706 40.6762 2.84299 40.6762H46.1035C46.8394 40.6762 47.5103 40.3961 48.0153 39.9371L26.2238 22.6488C25.1986 21.8352 23.7478 21.8352 22.7227 22.6488Z",
    fill: "#EFB525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9887 35.9496H5.9577L0.931152 39.9371C1.43619 40.3961 2.10706 40.6762 2.84299 40.6762H46.1035C46.8394 40.6762 47.5103 40.3961 48.0153 39.9371L42.9887 35.9496Z",
    fill: "#E2A61E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7227 26.459L0.931152 5.81683C1.43619 5.35782 2.10706 5.07812 2.84299 5.07812H46.1035C46.8394 5.07812 47.5103 5.35782 48.0153 5.81683L26.2238 26.459C25.1986 27.2727 23.7478 27.2727 22.7227 26.459Z",
    fill: "#FFD56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7593 46.8211H35.719C33.3771 46.8211 31.4788 44.9228 31.4788 42.5809V31.6895C31.4788 29.3476 33.3771 27.4489 35.719 27.4489H47.7593C50.1016 27.4489 51.9999 29.3476 51.9999 31.6895V42.5805C51.9999 44.9228 50.1016 46.8211 47.7593 46.8211Z",
    fill: "#45748C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7594 27.4489H46.1562V46.8211H47.7594C50.1017 46.8211 52.0001 44.9224 52.0001 42.5805V31.6895C52.0001 29.3476 50.1017 27.4489 47.7594 27.4489Z",
    fill: "#25687C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3406 31.5486H38.1384C37.9487 31.5486 37.7904 31.6954 37.7797 31.8847C37.7123 33.0975 37.1743 33.9838 36.1166 34.4194C35.979 34.4765 35.8913 34.6114 35.8957 34.7602C36.0607 40.4893 41.6863 44.0238 41.7395 44.0436C41.7926 44.0238 47.4182 40.4889 47.5833 34.7602C47.5876 34.6114 47.5004 34.4765 47.3627 34.4194C46.3046 33.9834 45.7671 33.0975 45.6992 31.8847C45.6885 31.6958 45.5302 31.5486 45.3406 31.5486Z",
    fill: "#71D6A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0812 40.0295C41.0788 40.0295 41.0765 40.0295 41.0741 40.0295C40.838 40.0271 40.6155 39.9188 40.4683 39.7347L39.0238 37.9272C38.7532 37.5884 38.8084 37.0949 39.1468 36.8243C39.4852 36.5533 39.9791 36.6085 40.2497 36.9473L41.0923 38.0018L43.7318 34.8177C44.0083 34.484 44.5034 34.4376 44.8367 34.7145C45.1703 34.991 45.2167 35.4857 44.9402 35.8194L41.6854 39.7454C41.5363 39.9251 41.3145 40.0295 41.0812 40.0295Z",
    fill: "#E9FEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0154 5.81683C47.5103 5.35782 46.8394 5.07812 46.1035 5.07812H43.0059V10.5625L48.0154 5.81683Z",
    fill: "#FFEB7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_1530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitIcon5);
export default __webpack_public_path__ + "static/media/kitIcon5.1cd9344fe62599bbfb6e9a81ebac1f09.svg";
export { ForwardRef as ReactComponent };